/**
 * Any Online Virtual Class API calls with React Query.
 */
import { useMemo } from "react";
import moment from "moment";
import { GetVritualClassDropdownCancelToken, GetListOfDashboardCancleToken } from "../../services/DashBoardServices";
import { QUERY_CACHE_PROFILES, QUERY_KEYS } from "../queryConsts";
import { useBaseReactQuery } from "./useBaseReactQuery";

const EMPTY_CLASSES_DROPDOWN_RAW = Object.freeze({
    bbb_server: [],
    class_type: [],
    course: [],
    intakes: [],
    lectures: [],
    statusType: [],
    studyType: [],
    showing: [],
});

const EMPTY_CLASSES_LIST = Object.freeze({
    onlineClassesList: [],
    totalRows: 0
});

export const OnlineClassesTabNames = {
    Today: "Today",
    Upcoming: "Upcoming",
    Past: "Past",
};

/**
 * Online Classes Dropdown - PERSISTED
 * @param {OnlineClassesTabNames} Tab Online Classes Tab name.
 * @returns {DefinedUseQueryResult} React Query result
 */
export function useOnlineClassesDropdown(filters) {
    const query = useBaseReactQuery(
        [QUERY_KEYS.onlineClasses.root, QUERY_KEYS.onlineClasses.onlineClassesDropdown, filters],
        async () => {
            const { data } = await GetVritualClassDropdownCancelToken(filters);
            return data;
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.LOOKUP
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_CLASSES_DROPDOWN_RAW
    };
}

/**
 * React Query hook for online virtual classes lists.
 * The requestData should already be in the format expected by the API.
 *
 * @param {object} requestData Request body passed directly to the API.
 * @returns {DefinedUseQueryResult}
 */
export function useOnlineClassesList(requestData) {
    const query = useBaseReactQuery(
        [
            QUERY_KEYS.onlineClasses.root,
            QUERY_KEYS.onlineClasses.onlineClassesList,
            requestData
        ],
        async () => {
            const { data } = await GetListOfDashboardCancleToken(requestData);
            return {
               onlineClassesList: data?.result1 ?? [],
                totalRows: data?.Pagination?.total ?? 0
            };
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.TABLE
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_CLASSES_LIST
    };
}
